'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import invariant from 'react-utils/invariant';

const getDefaultContent = property => {
  switch (property) {
    case 'type':
      return 'website';

    case 'title':
      {
        const {
          title
        } = document || {};
        return title;
      }

    case 'url':
      {
        const {
          href
        } = window.location || {};
        return href;
      }

    default:
      break;
  }

  return null;
};

const OpenGraphMeta = ({
  property: passedProperty,
  content: passedContent
}) => {
  const property = `og:${passedProperty}`;
  const content = passedContent || getDefaultContent(passedProperty);
  invariant(!!content, `OpenGraphMeta: content required to render ${property} meta tag`);
  return /*#__PURE__*/_jsx("meta", {
    property: property,
    content: content
  });
};

OpenGraphMeta.propTypes = {
  content: PropTypes.string,
  property: PropTypes.oneOf(['description', 'image', 'title', 'type', 'url']).isRequired
};
export default OpenGraphMeta;